module.exports = __webpack_public_path__ + "img/ko.0d0137c1.png";